export function formatToPhoneNumber(s: string, setPhoneNumber): void {
    if (s === undefined || s === null) return;

    const onlyNumbers = s?.replace(/[^0-9]/g, '')

    if (onlyNumbers.length < 10) {
        setPhoneNumber(onlyNumbers)
        return;
    }

    if (onlyNumbers.length === 10) {
        const number = onlyNumbers.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
        setPhoneNumber(number)
        return;
    }
}

export function removeNonNumbers(s: string): string {
    return s?.replace(/[^0-9]/g, '') ?? '';
}

export function formIsNotValid(firstName: any, lastName: any, countryCode: string, mobileNumber: string, confirMobileNumber: string): boolean {
    const notValid = true
    const valid = false

    if (!firstName) return notValid;
    if (!lastName) return notValid;
    if (!countryCode) return notValid;
    if (!mobileNumber) return notValid;
    if (mobileNumber.length < 10) return notValid;
    if (mobileNumber !== confirMobileNumber) return notValid;

    return valid;
}

export function determineIfUsaCompany(countryOfIncorporation: string): (() => string) {
    return () => {
        if (countryOfIncorporation === 'US') {
            return 'Yes';
        } else if (countryOfIncorporation === 'notUSA') {
            return 'No';
        } else {
            return '';
        }
    }
}

export function checkIfNumsDontMatch(n1: string, n2: string): boolean {
    const dontMatch = true
    const match = false
    const notApplicable = false

    if (n1 === '' || n2 === '') return notApplicable;

    if (n1 !== n2) return dontMatch;

    return match;
}

export function getPhoneNumberHelperText(isError: boolean): string {
    return isError ? 'Numbers do not match' : '';
}

export function getCompanyNameHelperText(isAcceptablName: boolean): string {
    return isAcceptablName ? 'Company name must be longer than 3 characters' : '';
}

export function checkIfCompanyNameIsNotAcceptable(name: string): boolean {
    const notAcceptable = true
    const acceptable = false
    const notApplicable = false

    if (name === '') return notApplicable;

    if (name.length < 4) return notAcceptable;

    return acceptable;
}

export function checkIfShouldDisableContinueButton(companyName: string, isUsa: string): boolean {
    const enable = false
    const disable = true

    if ((companyName !== '' && companyName.length > 3) && isUsa) return enable;

    return disable;
}

export function allowOnlyLettersDashesAndApostrophes(value: string): string {
    return value.replace(/[^a-z\-']/gi, '');
}
